'use client';

// FIXME https://github.com/getsentry/sentry-javascript/issues/15209
import * as Sentry from '@sentry/nextjs';
import { useEffect } from 'react';
import { dir } from 'i18next';

import { fallbackLng } from '@/app/utils/i18n';
import { rubik } from '@/app/utils/fonts';

import TranslationsProvider from '@/app/providers/TranslationsProvider';
import ErrorSplash from '@/app/components/ErrorSplash/ErrorSplash';

interface GlobalErrorPageProps {
  searchParams?: Record<string, string>;
  error: Error & { digest?: string };
}

export default function GlobalError({ error, searchParams }: GlobalErrorPageProps) {
  const locale = searchParams?.locale ?? fallbackLng;

  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang={locale} dir={dir(locale)}>
      <head>
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="format-detection" content="telephone=no" />
        <meta name="theme-color" content="#fff2e1" />
        <link rel="icon" type="image/png" href="/public/images/favicon/favicon.730909a8.png" />
        <link
          rel="apple-touch-icon"
          sizes="180x180"
          type="image/png"
          href="/public/images/favicon/apple-touch-icon.d3818922.png"
        />
        <link rel="icon" type="image/png" sizes="32x32" href="/public/images/favicon/favicon-32x32.c8b75b59.png" />
        <link rel="icon" type="image/png" sizes="16x16" href="/public/images/favicon/favicon-16x16.aa2bb9e3.png" />
      </head>
      <body className={rubik.className}>
        <TranslationsProvider>
          <main id="main-gradient" className="background-gradient min-h-[100vh] pt-[40px]">
            <ErrorSplash className="px-[24px] pt-[80px] pb-[120px]" />
          </main>
        </TranslationsProvider>
      </body>
    </html>
  );
}
